module.exports = __webpack_public_path__ + "static/media/slack.6cba8735.png";